import { FC } from "react";

import { useFullscreenOverlayVisibility } from "@ryde/redux";

import { AppBootstrapLoader } from "../app-bootstrap-loader";
import { LoaderMui } from "../loader-mui";

export const SessionGateLoader: FC = () => {
  const { isSessionOverlayVisible, isApiBackdropVisible, shouldLeaveLeftBar } =
    useFullscreenOverlayVisibility();

  return (
    <>
      <AppBootstrapLoader
        isVisible={isSessionOverlayVisible}
        shouldLeaveLeftBar={shouldLeaveLeftBar}
      />
      <LoaderMui loading={isApiBackdropVisible} />
    </>
  );
};
